if (!customElements.get('quick-view-images-modal')) {
  class QuickViewImagesModal extends ModalDialog {
    constructor() {
      super();

      this.gallery = this.querySelector('.quick-view-images-modal__images');
      this.dotsWrap = this.querySelector('.quick-view-images-modal__dots');
      this.prevBtn = this.querySelector('.quick-view-images-modal__nav--prev');
      this.nextBtn = this.querySelector('.quick-view-images-modal__nav--next');
      this.badgesEl = this.querySelector('.quick-view-images-modal__badges');
      this.titleEl = this.querySelector('.quick-view-images-modal__title');
      this.priceEl = this.querySelector('.quick-view-images-modal__price');
      this.addToCartBtn = this.querySelector('.quick-view-images-modal__add-to-cart');
      this.viewFullLink = this.querySelector('.quick-view-images-modal__view-full');
      this.loadingEl = this.querySelector('.quick-view-images-modal__loading');

      this.addToCartText = this.dataset.addToCartText || 'Add to cart';
      this.soldOutText = this.dataset.soldOutText || 'Sold out';

      this.images = [];
      this.activeIndex = 0;
      this.variantId = null;
      this.currentHandle = null;

      this.prevBtn.addEventListener('click', () => this.goToSlide(this.activeIndex - 1));
      this.nextBtn.addEventListener('click', () => this.goToSlide(this.activeIndex + 1));
      this.addToCartBtn.addEventListener('click', this.handleAddToCart.bind(this));
      this.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') this.goToSlide(this.activeIndex - 1);
        if (event.key === 'ArrowRight') this.goToSlide(this.activeIndex + 1);
      });
    }

    show(opener) {
      const handle = opener.getAttribute('data-product-handle');
      if (!handle) return;

      this.currentHandle = handle;
      this.variantId = null;

      // The trigger button lives as a sibling right before .card-wrapper
      // (kept out of .card__inner on purpose - see component-quick-view-images.css
      // for why nesting it there breaks click handling).
      const frame = opener.closest('.quick-view-images-frame');
      const cardWrapper = frame ? frame.nextElementSibling : null;

     if (opener.getAttribute('data-show-tags') === 'false') {
  this.badgesEl.innerHTML = '';
} else {
  this.populateBadges(
    opener.getAttribute('data-product-usp'),
    opener.getAttribute('data-metal'),
    opener.getAttribute('data-tags')
  );
}
      this.populateFromCard(cardWrapper);
      this.resetAddToCartButton();

      super.show(opener);
      this.fetchProduct(handle);
    }

    populateBadges(usp, metal, tags) {
  this.badgesEl.innerHTML = '';

  let labels = [];

  if (usp) {
    labels = usp.split(',').map((item) => item.trim()).filter(Boolean).slice(0, 4);
  } else {
    if (metal) labels.push(metal);
    if (tags) labels.push(...tags.split('|').filter(Boolean));

    // Some raw metal/tag values get shown as a friendlier label instead
    // of the raw text verbatim. Matched against a normalized form
    // (underscore/hyphen -> space, lowercased) so "925_Silver",
    // "925-Silver", "925 Silver" etc. all resolve the same way regardless
    // of which exact separator/casing was used when the value was set.
    labels = labels.map((label) => {
      const normalized = label.replace(/[_-]/g, ' ').toLowerCase();
      if (normalized.includes('925 silver')) return 'PURE 925 SILVER';
      if (normalized.includes('bis hallmarked')) return 'BIS-Hallmarked Gold';
      if (normalized.includes('hypoallergenic') || normalized.includes('sensitive skin')) return 'HYPOALLERGENIC';
      return label;
    });
  }

  labels.forEach((label) => {
    const badge = document.createElement('span');
    badge.className = 'quick-view-images-modal__badge';
    badge.textContent = label;
    this.badgesEl.appendChild(badge);
  });
}

    populateFromCard(cardWrapper) {
      let fallbackImage = null;

      if (cardWrapper) {
        const headingLink = cardWrapper.querySelector('.card__heading a');
        if (headingLink) {
          const clone = headingLink.cloneNode(true);
          clone.querySelectorAll('script, [id^="best-price-box"]').forEach((el) => el.remove());
          this.titleEl.textContent = clone.textContent.trim();
          this.viewFullLink.setAttribute('href', headingLink.getAttribute('href'));
        }

        const priceEl = cardWrapper.querySelector('.price');
        if (priceEl) {
          this.priceEl.className = `quick-view-images-modal__price ${priceEl.className}`;
          this.priceEl.innerHTML = priceEl.innerHTML;
        }

        const cardImage = cardWrapper.querySelector('.card__media img');
        if (cardImage) fallbackImage = cardImage.currentSrc || cardImage.src;
      }

      this.renderImages(fallbackImage ? [fallbackImage] : []);
    }

    async fetchProduct(handle) {
      this.loadingEl.classList.remove('hidden');
      try {
        const response = await fetch(`/products/${handle}.js`);
        if (!response.ok) throw new Error('Could not load product');
        const product = await response.json();

        // A newer click may have opened a different product while this was in flight.
        if (this.currentHandle !== handle) return;

        if (product.images && product.images.length) {
          this.renderImages(product.images);
        }

        const variant = product.variants.find((item) => item.available) || product.variants[0];
        this.variantId = variant ? variant.id : null;
        this.currentProductTitle = product.title || '';
        this.currentProductImage = product.featured_image || (product.images && product.images[0]) || '';
        this.addToCartBtn.disabled = !variant || !variant.available;
        this.addToCartBtn.textContent = variant && variant.available ? this.addToCartText : this.soldOutText;
      } catch (error) {
        console.error('[quick-view-images]', error);
      } finally {
        if (this.currentHandle === handle) this.loadingEl.classList.add('hidden');
      }
    }

    renderImages(images) {
      this.images = images;
      this.activeIndex = 0;

      this.gallery.style.transform = 'translateX(0)';
      this.gallery.innerHTML = images
        .map(
          (src, index) => `
            <img
              class="quick-view-images-modal__image"
              src="${this.sizedUrl(src)}"
              loading="${index === 0 ? 'eager' : 'lazy'}"
              alt=""
            >
          `
        )
        .join('');

      this.dotsWrap.innerHTML = images
        .map(
          (_, index) => `
            <button
              type="button"
              class="quick-view-images-modal__dot${index === 0 ? ' is-active' : ''}"
              aria-label="Show image ${index + 1}"
            ></button>
          `
        )
        .join('');

      this.dotsWrap.querySelectorAll('.quick-view-images-modal__dot').forEach((dot, index) => {
        dot.addEventListener('click', () => this.goToSlide(index));
      });

      const hasMultiple = images.length > 1;
      this.prevBtn.classList.toggle('hidden', !hasMultiple);
      this.nextBtn.classList.toggle('hidden', !hasMultiple);
      this.dotsWrap.classList.toggle('hidden', !hasMultiple);
    }

    sizedUrl(src) {
      if (!src) return src;
      return `${src}${src.includes('?') ? '&' : '?'}width=800`;
    }

    goToSlide(index) {
      if (!this.images.length) return;
      this.activeIndex = (index + this.images.length) % this.images.length;

      // Each slide is 85% wide with no gap, so the next one peeks in on the
      // right. The last slide is clamped so it lands flush against the right
      // edge instead of leaving a trailing gap after it.
      const slideStep = 85;
      const maxStep = Math.max(this.images.length * slideStep - 100, 0);
      const step = Math.min(this.activeIndex * slideStep, maxStep);
      this.gallery.style.transform = `translateX(-${step}%)`;
      this.dotsWrap.querySelectorAll('.quick-view-images-modal__dot').forEach((dot, i) => {
        dot.classList.toggle('is-active', i === this.activeIndex);
      });
    }

    resetAddToCartButton() {
      this.addToCartBtn.disabled = false;
      this.addToCartBtn.classList.remove('loading');
      this.addToCartBtn.textContent = this.addToCartText;
    }

    async handleAddToCart() {
      if (!this.variantId || this.addToCartBtn.disabled) return;

      this.addToCartBtn.classList.add('loading');
      this.addToCartBtn.disabled = true;

      try {
        let showCustomCart = localStorage.getItem('showCustomCart');
        if (showCustomCart !== 'true' && showCustomCart !== 'false') {
          if (typeof waitForShowCustomCartFlag === 'function') {
            showCustomCart = await waitForShowCustomCartFlag();
          }
        }
        if (showCustomCart === 'true') {
          const refId =
            typeof waitForCustomCartRefId === 'function'
              ? await waitForCustomCartRefId()
              : await generateCustomCartRefId();
          if (!refId) return;
          await this.addToCustomCart();
        } else {
          await this.addToShopifyCart();
        }
        this.addToCartBtn.textContent = 'Added!';
        setTimeout(() => this.resetAddToCartButton(), 2000);
      } catch (error) {
        console.error('[quick-view-images]', error);
        this.addToCartBtn.textContent = 'Something went wrong';
        setTimeout(() => this.resetAddToCartButton(), 2000);
      } finally {
        this.addToCartBtn.classList.remove('loading');
      }
    }

    // Native Shopify cart path - used when showCustomCart is not "true".
    async addToShopifyCart() {
      const cartElement = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const sections =
        cartElement && typeof cartElement.getSectionsToRender === 'function'
          ? cartElement.getSectionsToRender().map((section) => section.section || section.id)
          : [];

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: this.variantId,
          quantity: 1,
          sections: sections.join(','),
          sections_url: window.location.pathname,
        }),
      });
      const data = await response.json();
      if (data.status) throw new Error(data.description || 'Could not add to cart');

      if (cartElement && typeof cartElement.renderContents === 'function') {
        cartElement.renderContents(data);
      }
    }

    // Custom bifrost cart path - used when showCustomCart is "true".
    // Mirrors the flow in product-form.js's onCustomSubmitHandler, scoped down
    // to a single-item add since the modal has no form/personalisation inputs.
    async addToCustomCart() {
      const userId = window.__st && window.__st.cid ? `${window.__st.cid}` : await window.visitor_id;
      const refId = await generateCustomCartRefId();

      let cartId;
      try {
        const res = await fetch('https://prod-bifrost.giva-api.com/api/cart/user', {
          headers: { ref_access_token: refId },
        });
        if (res.ok) {
          const data = await res.json();
          cartId = data && data.data && data.data.cart ? data.data.cart.id : undefined;
          if (cartId && cartId.length === 0) cartId = undefined;
        }
      } catch (err) {
        console.log('Cart fetch failed', err);
      }

      const item = { item_id: String(this.variantId), quantity: 1 };

      const response = !cartId
        ? await fetch('https://prod-bifrost.giva-api.com/api/cart', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', ref_access_token: refId },
            body: JSON.stringify({
              cart_type: 'primary',
              user_id: userId,
              items: [item],
              payment: { payment_methods: [] },
              benefits: { coupons: [] },
              serviceability_option: { shipments: [] },
              shipping_address: {},
              billing_address: {},
            }),
          })
        : await fetch('https://prod-bifrost.giva-api.com/api/cart/update-items', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', ref_access_token: refId },
            body: JSON.stringify({
              cart_id: cartId,
              user_id: userId,
              items: [{ item: item, operation: 'add' }],
              shipping_address: {},
              billing_address: {},
            }),
          });

      const data = await response.json();
      if (!data.success) throw new Error('Could not add to cart');

      const totalCartItems = data.data.cart.items
        .filter((cartItem) => cartItem.item_id != '31471233106010')
        .map((cartItem) => cartItem.quantity)
        .reduce((a, b) => a + b, 0);

      document.querySelectorAll('.header__icon--cart').forEach((el) => {
        if (el.getAttribute('id') === 'cart-icon-bubble') {
          const bubble = el.querySelector('#cart-count-bubble');
          if (bubble) {
            bubble.querySelectorAll('span').forEach((span) => {
              span.innerHTML = totalCartItems;
            });
          }
        }
      });

      if (typeof this.createCustomNotificationPopup === 'function') {
        this.createCustomNotificationPopup({
          product_title: this.currentProductTitle || this.titleEl.textContent,
          final_line_price: this.priceEl ? this.priceEl.textContent.trim() : '',
          image: this.currentProductImage || (this.images && this.images[0]) || '',
          totalCartItems: totalCartItems,
        });
      }
    }

    // Reuses the same popup markup/behaviour as product-form.js so the
    // confirmation looks identical no matter which flow added the item.
    createCustomNotificationPopup(item) {
      const popupHTML = `<cart-notification class="custom-cart-notification">
        <div class="cart-notification-overlay active" id="cart-notification-overlay">
          <div class="cart-notification-wrapper page-width">
            <div id="cart-notification" class="cart-notification focus-inset color-background-1 gradient animate active" aria-modal="true" aria-label="Item added to your cart" role="dialog" tabindex="-1">
              <div class="cart-notification__header">
                <h2 class="cart-notification__heading caption-large text-body"><svg class="icon icon-checkmark" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 9" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M11.35.643a.5.5 0 01.006.707l-6.77 6.886a.5.5 0 01-.719-.006L.638 4.845a.5.5 0 11.724-.69l2.872 3.011 6.41-6.517a.5.5 0 01.707-.006h-.001z" fill="currentColor"></path>
      </svg>
      Item added to your cart
                </h2>
                <button type="button" class="cart-notification__close modal__close-button link link--text focus-inset" aria-label="Close">
                  <svg class="icon icon-close" aria-hidden="true" focusable="false">
                    <use href="#icon-close">
                  </use></svg>
                </button>
              </div>
              <div id="cart-notification-product" class="cart-notification-product"><div class="cart-notification-product__image global-media-settings">
                <img src="${item.image}" alt="" width="70" height="70" loading="lazy">
              </div><div><h3 class="cart-notification-product__name h4">${item.product_title}</h3>
              <h3 class="cart-notification-product__price h4">${item.final_line_price}</h3>
              </div>
          </div>
              <div class="cart-notification__links">
                <button type="button" class="button button--secondary button--full-width view-cart-btn">View cart (${item.totalCartItems})</button>
                <button type="button" class="link button-label medium-hide large-up-hide">Continue shopping</button>
              </div>
            </div>
          </div>
        </div>
      </cart-notification>`;

      const header = document.body.querySelector('.shopify-section-header-sticky');
      if (!header) return;
      header.insertAdjacentHTML('beforeend', popupHTML);

      const customNotification = header.querySelector('.custom-cart-notification:last-of-type');
      const viewCartBtn = customNotification && customNotification.querySelector('.view-cart-btn');
      if (viewCartBtn) {
        viewCartBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopImmediatePropagation();
          if (typeof openCustomCartPage === 'function') openCustomCartPage();
        }, true);
      }

      const closeBtn = customNotification && customNotification.querySelector('.cart-notification__close');
      if (closeBtn) {
        closeBtn.addEventListener('click', () => {
          customNotification.remove();
        });
      }
      const continueBtn = customNotification && customNotification.querySelector('.cart-notification__links .button-label');
      if (continueBtn) {
        continueBtn.addEventListener('click', () => {
          customNotification.remove();
        });
      }
    }
  }

  customElements.define('quick-view-images-modal', QuickViewImagesModal);
}